import api from '@/utils/api';

/**
 * Update quote
 * @param {string} id quote id
 * @param {object} quoteData - The quote data
 * @returns {Promise}
 */
const updateQuoteApi = (id, quoteData) => api.patch(`/quote/${id}`, quoteData);

export default updateQuoteApi;
